var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"text-2xl my-4"},[_vm._v("Estudiantes")]),_c('a-table',{attrs:{"bordered":"","rounded":"","source":_vm.pagination.data,"columns":_vm.columns,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }